import Accordion from 'react-bootstrap/Accordion';
import * as S from "../../../css/SignUp/RegularUser.style"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
function AccordianCorporationUser({
    regObj, 
    setRegObj, 
    setIsChecked, 
    isChecked1, 
    setIsChecked1, 
    isChecked2, 
    setIsChecked2,
    isChecked3, 
    setIsChecked3,
    isChecked4, 
    setIsChecked4
}) {
    const handleIconClick1 = (e) => {
        e.stopPropagation();
        setIsChecked1(!isChecked1);
        setRegObj({...regObj, agree_yn:'Y'})
        if (isChecked1){
            setIsChecked1(false)
            setRegObj({...regObj, agree_yn:'N'})
        }
    };

    const handleIconClick2 = (e) => {
        e.stopPropagation();
        setIsChecked2(!isChecked2);
        setRegObj({...regObj, privacy_yn:'Y'})
        if (isChecked2){
            setIsChecked2(false)
            setRegObj({...regObj, privacy_yn:'N'})
        }
    };

    const handleIconClick3 = (e) => {
        e.stopPropagation();
        setIsChecked3(!isChecked3);
        setRegObj({...regObj, alarm_yn:'Y'})
        if (isChecked3){
            setIsChecked3(false)
            setRegObj({...regObj, alarm_yn:'N'})
        }
    };

    const handleIconClick4 = (e) => {
        e.stopPropagation();
        setIsChecked4(!isChecked4);
        setRegObj({...regObj, ads_yn:'Y'})
        if (isChecked4){
            setIsChecked4(false)
            setRegObj({...regObj, ads_yn:'N'})
        }
    };

    return (
      <Accordion>
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            <S.AccordionHeading padding={"0"}>
              {isChecked1 ? (
                <S.AccordionIcon onClick={handleIconClick1}>
                  <FontAwesomeIcon icon={faCheck} />
                </S.AccordionIcon>
              ) : (
                <S.AccordionIcon color="#DADADA" onClick={handleIconClick1}>
                  <FontAwesomeIcon icon={faCheck} />
                </S.AccordionIcon>
              )}
              <S.AccordionValue color="#888888">
                서비스 이용 약관(필수)
              </S.AccordionValue>
            </S.AccordionHeading>
          </Accordion.Header>
          <Accordion.Body>
            <S.AccordionCollapse_Text>
              (주)어셈브릭스의 “탑탑” 웹사이트의 이용과 관련 한 제반 서비스의
              이용에 대한 필요한 사항을 규정합니다.
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              <strong>제1조 [목 적]</strong>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              이 약관은 (주)어셈브릭스가 운영하는 탑탑
              웹사이트(http://www.top-top.kr, 이하 “탑탑”라 한다)에서 제공하는
              인터넷 관련 서비스 및 기타 부대서비스의 이용조건 및 절차에 관한
              기본적인 사항을 정함을 목적으로 합니다.
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              <strong>제2조 [정 의]</strong>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              이 약관에서 사용하는 용어의 정의는 다음과 같습니다.
              <br />
              ① "탑탑"란 (주)어셈브릭스가 운영하는
              온라인사이트(http://www.top-top.kr)로서 화물자동차 운송사업 및
              운송주선사업 허가증(이하 “운송사업허가증”) 매매 관련 정보의 게시
              또는 열람(이하 “온라인서비스) 및 “운송사업허가증”의 양도·양수 중개
              및 행정업무 대행(이하 “중개서비스”)과 관련 제반 상품 서비스를
              제공하는 사이트를 의미합니다.
              <br />
              ② "서비스"라 함은 구현되는 단말기(PC, 휴대형 단말기 등의 각종
              유무선 장치)와 상관 없이 “이용자”가 이용할 수 있는 "탑탑"이
              제공하는 재화의 공급 및 용역이행을 말합니다.
              <br />
              ③ "이용자"란 "탑탑"에 접속하여 이 약관에 따라 “탑탑”이 제공하는
              서비스를 받는 회원 및 비회원을 말합니다.
              <br />
              ④ "회원"이라 함은 "탑탑"에 개인정보를 제공하여 회원등록을 한
              자로서, "탑탑"의 정보를 지속적으로 제공받으며, “탑탑”이 제공하는
              서비스를 계속적으로 이용할 수 있는 자를 말합니다.
              <br />
              ⑤ "비회원"이라 함은 회원에 가입하지 않고 “탑탑”이 제공하는
              서비스를 이용하는 자를 말합니다.
              <br />
              ⑥ "쿠폰"이라 함은 회원에게 “탑탑”에서 제공되는 유료 “서비스” 결제
              시 일정금액 또는 일정비율을 할인 받을 수 있는 사이버 쿠폰을
              말합니다.
              <br />
              ⑦ “포인트”라 함은 회원이 “탑탑”에서 제공되는 유료 “서비스” 결제 시
              현금처럼 사용할 수 있는 회사 전용의 사이버 화폐를 말합니다.
              <br />⑧ “매물”이라 함은 회원 혹은 “탑탑”이 삽니다 혹은 팝니다
              메뉴에 등록한 화물운송사업허가증 및 운송주선사업허가증 등
              매매하고자 게시 한 정보를 말합니다.
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              <strong>제3조 [약관의 명시와 개정]</strong>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              ① (주)어셈브릭스는 “탑탑” 약관의 내용과 상호, 영업소 소재지,
              대표자의 성명, 연락처(전화, 팩스, 전자우편 주소 등) 등을 이용자가
              알 수 있도록 탑탑의 초기화면에 게시합니다.
              <br />
              ② (주)어셈브릭스는 “약관의규제에관한법률”, “전자거래기본법”,
              “전자서명법”, “정보통신망이용촉진등에관한법률”,
              “방문판매등에관한법률”, “소비자보호법” 등 관련법을 위배하지 않는
              범위에서 약관을 개정할 수 있습니다.
              <br />
              ③ (주)어셈브릭스가 약관을 개정할 경우에는 적용일자 및 개정사유를
              명시하여 현행약관과 함께 탑탑의 초기화면에 그 적용일자 7일
              이전부터 적용일자 전일까지 공지합니다. 다만, 회원에게 불리한 약관
              개정의 경우 공지 외에 일정기간 서비스내 전자우편, 전자쪽지,
              로그인시 동의창 등의 전자적 수단을 통해 따로 명확히 통지하도록
              합니다.
              <br />
              ④ (주)어셈브릭스 전항에 따라 개정약관을 공지 또는 통지하면서
              회원에게 7일 기간 내에 의사표시를 하지 않으면 의사표시가 표명된
              것으로 본다는 뜻을 명확하게 공지 또는 통지하였음에도 회원이
              명시적으로 거부의 의사표시를 하지 아니한 경우 회원이 개정약관에
              동의한 것으로 봅니다.
              <br />
              ⑤ (주)어셈브릭스는 회원이 개정약관의 적용에 동의하지 않는 경우
              개정 약관의 내용을 적용할 수 없으며, 이 경우 회원은 이용계약을
              해지할 수 있습니다. 다만, 기존 약관을 적용할 수 없는 특별한 사정이
              있는 경우에는 (주)어셈브릭스는 이용계약을 해지할 수 있습니다.
              <br />⑥ 이 약관에서 정하지 아니한 사항과 이 약관의 해석에 관하여는
              정부가 제정한 “전자거래소비자보호지침” 및 관계법령 또는 상관례에
              따릅니다.
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              <strong>제4조 [서비스 이용계약의 성립]</strong>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              ① 서비스 이용계약은 회원이 되고자 하는 자가 본 이용약관에
              동의하고, 가입신청 절차에 따라 회원가입신청을 하고
              (주)어셈브릭스가 이러한 신청에 대하여 승낙함으로써 성립됩니다.
              <br />
              ② (주)어셈브릭스는 가입신청자의 신청에 대하여 서비스 이용을
              승낙함을 원칙으로 합니다. 다만, (주)어셈브릭스는 다음 각 호에
              해당하는 신청에 대하여는 승낙을 하지 않거나 사후에 이용계약을
              해지할 수 있습니다.
              <br />
              &nbsp;&nbsp;&nbsp; 1. 가입신청자가 이 약관에 의하여 이전에
              회원자격을 상실한 적이 있는 경우, 단 (주)어셈브릭스가 회원 재가입
              승낙을 한 경우에는 예외로 함<br />
              &nbsp;&nbsp;&nbsp; 2. 신청 내용에 허위, 기재누락, 오기가 있는 경우
              <br />
              &nbsp;&nbsp;&nbsp; 3. 이용자의 귀책사유로 인하여 승인이
              불가능하거나 기타 규정한 제반 사항을 위반하며 신청하는 경우
              <br />
              ③ (주)어셈브릭스는 가입신청자의 신청에 대하여 서비스 이용을
              승낙함을 원칙으로 합니다. 다만, (주)어셈브릭스는 다음 각 호에
              해당하는 신청에 대하여는 승낙을 하지 않거나 사후에 이용계약을
              해지할 수 있습니다.
              <br />
              ④ (주)어셈브릭스는 제1항에 따른 신청에 있어 회원가입신청자에 대한
              실명확인 및 본인 인증 요청을 할 수 있습니다.
              <br />
              ⑤ (주)어셈브릭스는 서비스관련설비의 여유가 없거나, 기술상 또는
              업무상 문제가 있는 경우 회원가입승낙을 유보할 수 있습니다.
              <br />⑥ (주)어셈브릭스는제2항과 제4항에 따라 회원가입신청의 승낙을
              하지 아니하거나 유보한 경우, 원칙적으로 이를 가입신청자에게 거나
              유보한 경우, 원칙적으로 이를 가입신청자에게 알리도록 합니다.
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              <strong>제5조 [회원가입 및 정보의 변경]</strong>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              ① 이용자는 “탑탑”이 정한 가입양식에 따라 회원정보를 기입한 후 이
              약관에 동의한다는 의사표시를 함으로서 회원가입을 신청합니다.
              <br />
              ② 이용자가 다음 각호의 사유가 있는 경우에는 회원가입이 제한될 수
              있습니다
              <br />
              &nbsp;&nbsp;&nbsp; 1. 제6조 1항에 의거 회원 탈퇴한 경우
              탈퇴일로부터 1개월 이내
              <br />
              &nbsp;&nbsp;&nbsp; 2. 가입신청자가 이 약관 제6조 3항에 의하여
              이전에 회원자격을 상실한 적이 있는 경우, 다만 제6조 3항에 의한
              회원자격 상실 후 3년이 경과한 자로서 “탑탑”의 회원재가입 승낙을
              얻은 경우에는 예외로 한다.
              <br />
              &nbsp;&nbsp;&nbsp; 3. 등록 내용에 허위, 기재누락, 오기가 있는 경우
              <br />
              &nbsp;&nbsp;&nbsp; 4. 기타 회원으로 등록하는 것이 “탑탑”의 기술상
              현저히 지장이 있다고 판단되는 경우
              <br />
              &nbsp;&nbsp;&nbsp; 5. 회원의 나이가 만 14세 미만일 경우
              <br />
              ③ 회원가입계약의 성립시기는 “탑탑”의 승낙이 회원에게 도달한
              시점으로 합니다.
              <br />
              ④ 회원은 제8조 1항에 의한 등록사항에 변경이 있는 경우, 즉시
              전자우편 또는 기타 방법으로 “탑탑”에 대하여 그 변경사항을 알려야
              합니다.
              <br />
              ⑤ 회원은 개인정보관리화면을 통하여 언제든지 본인의 개인정보를
              열람하고 수정할 수 있습니다. 다만, 서비스 관리를 위해 필요한 실명,
              주민등록번호, 아이디 등은 수정이 불가능합니다.
              <br />
              ⑥ 회원은 회원가입신청 시 기재한 사항이 변경되었을 경우 온라인으로
              수정하거나 전자우편 기타 방법으로 (주)어셈브릭스에 그 변경사항을
              알려야 합니다.
              <br />⑦ 회원이 제6항의 변경사항을 알리지 않아 발생한 불이익에
              대하여 (주)어셈브릭스에게 귀책사유가 있는 부분을 제외하고는 회원이
              책임을 부담합니다.
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              <strong>제6조 [회원 탈퇴 및 자격상실]</strong>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              ① 회원은 언제든지 (주)어셈브릭스에 회원 탈퇴를 요청할 수 있으며,
              (주)어셈브릭스는 즉시 회원탈퇴를 처리합니다.
              <br />
              ② (주)어셈브릭스는 회원이 다음 각호의 사유에 해당하는 경우,
              회원자격을 제한 및 정지시킬 수 있습니다.
              <br />
              &nbsp;&nbsp;&nbsp; 1. 가입 신청시에 허위 내용을 등록한 경우
              <br />
              &nbsp;&nbsp;&nbsp; 2. “탑탑”을 이용하여 구입한 서비스 등의 대금,
              기타 “탑탑”이용에 관련하여 회원이 부담하는 채무를 기일에 지급하지
              않는 경우
              <br />
              &nbsp;&nbsp;&nbsp; 3. 다른 사람의 서비스이용을 방해하거나 그
              정보를 도용하는 등 전자거래질서를 위협하는 경우
              <br />
              &nbsp;&nbsp;&nbsp; 4. 서비스 이용 중 법령과 이 약관이 금지하거나
              공서양속에 반하는 행위를 하는 경우
              <br />
              &nbsp;&nbsp;&nbsp; 5. 등록매물에 대하여 보복성 허위 신고를 하거나
              허위 신고 행위가 반복되는 경우
              <br />
              ③ (주)어셈브릭스가 회원 자격을 제한 또는 정지 시킨 후, 동일한
              행위가 2회이상 반복되거나 30일이내에 그 사유가 시정되지 아니하는
              경우 (주)어셈브릭스는 회원자격을 상실시킬 수 있습니다.
              <br />④ (주)어셈브릭스가 회원자격을 상실시키는 경우에는 회원등록을
              말소합니다. 이 경우 회원에게 이를 통지하고, 회원등록 말소 전에
              소명할 기회를 부여합니다.
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              <strong>제7조 [회원에 대한 통지]</strong>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              ① (주)어셈브릭스가 회원에 대한 통지를 하는 경우, 회원이 회원가입
              시 기재한 전자우편 주소로 할 수 있습니다.
              <br />② (주)어셈브릭스는 회원 전체에 대한 통지의 경우 7일 이상
              탑탑 웹사이트(http://www.top-top.kr)의 편의(공지사항)란에
              게시함으로써 제1항의 통지에 갈음할 수 있습니다.
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              <strong>제8조 [개인정보보호]</strong>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              ① (주)어셈브릭스는 이용자의 정보수집 시 구매계약 이행에 필요한
              최소한의 정보를 수집합니다. 다음 사항을 필수사항으로 하며 그 외
              사항은 선택사항으로 합니다.
              <br />
              &nbsp;&nbsp;&nbsp; 1. 성명 2. 실명확인값 3.i-pin번호 4.
              전자우편주소 5. 희망ID 6. 비밀번호 7. 사용자 구분(개인, 법인)
              <br />
              ② (주)어셈브릭스는 이용자의 개인식별이 가능한 개인정보를 수집한
              때에는 반드시 당해 이용자의 동의를 받습니다.
              <br />
              ③ 제공된 개인정보는 당해 이용자의 동의 없이 목적 외의 이용이나
              제3자에게 제공할 수 없으며, 이에 대한 모든 책임은 (주)어셈브릭스가
              집니다. 다만, 다음의 경우에는 예외로 합니다.
              <br />
              &nbsp;&nbsp;&nbsp; 1. 서비스이행을 위해 제휴서비스 제공에 필요한
              최소한의 이용자의 정보를 제휴업체에 알려주는 경우
              <br />
              &nbsp;&nbsp;&nbsp; 2. 통계작성, 학술연구 또는 시장조사를 위하여
              필요한 경우로서 특정 개인을 식별할 수 없는 형태로 제공하는 경우
              <br />
              &nbsp;&nbsp;&nbsp; 3. 관계법령에 의한 경우
              <br />
              ④ (주)어셈브릭스는 제2항과 제3항에 의해 이용자의 동의를 받아야
              하는 경우에는 개인정보관리책임자의 신원(소속, 성명 및 전화번호
              기타 연락처), 정보의 수집목적 및 이용목적, 제3자에 대한 정보제공
              관련사항(제공받는자, 제공목적 및 제공할 정보의 내용)등
              “정보통신망이용촉진등에관한법률” 제16조 3항이 규정한 사항을 미리
              명시하거나 고지해야 하며 이용자는 언제든지 이 동의를 철회할 수
              있습니다.
              <br />
              ⑤ 이용자는 언제든지 (주)어셈브릭스가 가지고 있는 자신의 개인정보에
              대해 열람 및 오류정정을 요구할 수 있으며 (주)어셈브릭스는 이에
              대해 지체 없이 필요한 조치를 취할 의무를 집니다. 이용자가 오류의
              정정을 요구한 경우에는 (주)어셈브릭스는 그 오류를 정정할 때까지
              당해 개인정보를 이용하지 않습니다.
              <br />
              ⑥ (주)어셈브릭스는 개인정보 보호를 위하여 관리자를 한정하여 그
              수를 최소화하며 신용카드, 은행계좌 등을 포함한 이용자의 개인정보의
              분실, 도난, 유출, 변조 등으로 인한 이용자의 손해를 방지하기 위해
              최선의 노력을 다합니다.
              <br />⑦ (주)어셈브릭스 또는 그로부터 개인정보를 제공받은 제3자는
              개인정보의 수집목적 또는 제공받은 목적을 달성한 때에는 당해
              개인정보를 지체 없이 파기합니다.
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              <strong>
                제9조 [회원의 아이디 및 비밀번호 관리에 대한 의무]
              </strong>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              ① 회원의 "아이디"와 "비밀번호"에 관한 관리책임은 회원에게 있으며,
              이를 제3자가 이용하도록 하여서는 안 됩니다.
              <br />
              ② (주)어셈브릭스는 회원의 "아이디"가 개인정보 유출 우려가 있거나,
              반사회적 또는 미풍양속에 어긋나거나 (주)어셈브릭스 및
              (주)어셈브릭스의 운영자로 오인한 우려가 있는 경우, 해당 "아이디"의
              이용을 제한할 수 있습니다.
              <br />
              ③ 회원은 "아이디" 및 "비밀번호"가 도용되거나 제3자가 사용하고
              있음을 인지한 경우에는 이를 즉시 (주)어셈브릭스에 통지하고
              (주)어셈브릭스의 안내에 따라야 합니다.
              <br />④ 제3항의 경우에 해당 회원이 (주)어셈브릭스에 그 사실을
              통지하지 않거나, 통지한 경우에도 (주)어셈브릭스의 안내에 따르지
              않아 발생한 불이익에 대하여 (주)어셈브릭스는 책임지지 않습니다.
              다만 (주)어셈브릭스의 귀책사유가 경합하여 그러한 불이익이 발생한
              경우에는 관계법령에 따라 책임을 부담합니다.
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              <strong>제10조 [(주)어셈브릭스의 의무]</strong>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              ① (주)어셈브릭스는 법령과 이 약관이 금지하거나 공서양속에 반하는
              행위를 하지 않으며 이 약관이 정하는 바에 따라 지속적이고,
              안정적으로 서비스를 제공하는 데 최선을 다하여 노력합니다.
              <br />
              ② (주)어셈브릭스는 이용자가 안전하게 인터넷 서비스를 이용할 수
              있도록 이용자의 개인정보(신용정보 포함) 보호를 위한 보안 시스템을
              갖추어야 합니다.
              <br />
              ③ (주)어셈브릭스는 서비스이용과 관련하여 발생하는 이용자의 불만
              또는 피해구제요청을 적절하게 처리할 수 있도록 필요한 인력 및
              시스템을 구비합니다.
              <br />
              ④ (주)어셈브릭스는 서비스이용과 관련하여 회원으로부터 제기된
              의견이나 불만이 정당하다고 인정할 경우에는 이를 처리하여야 합니다.
              회원이 제기한 의견이나 불만사항에 대해서는 게시판을 활용하거나
              전자우편 등을 통하여 회원에게 처리과정 및 결과를 전달합니다.
              <br />⑤ (주)어셈브릭스는 이용자가 원하지 않는 영리목적의 광고성
              전자우편을 발송하지 않습니다.
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              <strong>제11조 [이용자의 의무]</strong>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              ① 이용자는 다음 행위를 하여서는 안되며, 이에 대한 법률적인 책임은
              이용자에게 있습니다.
              <br />
              &nbsp;&nbsp;&nbsp; 1. 신청 또는 변경시 허위내용의 등록
              <br />
              &nbsp;&nbsp;&nbsp; 2. (주)어셈브릭스에 게시된 정보의 변경
              <br />
              &nbsp;&nbsp;&nbsp; 3. (주)어셈브릭스가 정한 정보 이외의
              정보(컴퓨터 프로그램 등)를 송신 또는 게시
              <br />
              &nbsp;&nbsp;&nbsp; 4. (주)어셈브릭스의 서비스를 이용하여 얻은
              정보를 승낙 없이 복제 유통하거나 상업적으로 이용하는 행위
              <br />
              &nbsp;&nbsp;&nbsp; 5. (주)어셈브릭스 기타 제3자의 저작권 등
              지적재산권에 대한 침해
              <br />
              &nbsp;&nbsp;&nbsp; 6. (주)어셈브릭스 기타 제3자의 명예를
              손상시키거나 업무를 방해하는 행위
              <br />
              &nbsp;&nbsp;&nbsp; 7. 외설 또는 폭력적인 메시지,화상,음성 기타
              공서양속에 반하는 정보를 “탑탑”에 공개 또는 게시하는 행위
              <br />
              &nbsp;&nbsp;&nbsp; 8. 서비스와 관련된 설비의 오작동이나 정보 등의
              파괴와 혼란을 유발하는 컴퓨터 바이러스 감염자료를 등록하거나
              유포하는 행위
              <br />
              &nbsp;&nbsp;&nbsp; 9. (주)어셈브릭스의 직원이나 운영자로 가장 또는
              속이거나 타인의 명의를 무단으로 사용하여 글을 게시하거나 이메일을
              발송하는 행위
              <br />
              &nbsp;&nbsp;&nbsp; 10. 기타 불법적이거나 부당한 행위
              <br />② 회원은 관계법, 이 약관의 규정, 이용안내 및 "서비스"와
              관련하여 공지한 주의사항, (주)어셈브릭스가 통지하는 사항 등을
              준수하여야 하며, 기타 (주)어셈브릭스의 업무에 방해되는 행위를
              하여서는 안 됩니다.
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              <strong>제12조 [서비스의 제공 및 변경]</strong>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              ① (주)어셈브릭스는 “탑탑”을 통해 다음과 같은 업무를 수행합니다.
              <br />
              &nbsp;&nbsp;&nbsp; 1. 화물자동차 운송사업 및 운송주선사업 허가증
              시세 정보
              <br />
              &nbsp;&nbsp;&nbsp; 2. 화물자동차 운송사업 및 운송주선사업 허가증
              매매 및 중개관련 정보제공
              <br />
              &nbsp;&nbsp;&nbsp; 3. 이용자의 자동차 매매 및 중개과정에서 발생할
              수 있는 금융 및 보험관련 정보의 제공
              <br />
              &nbsp;&nbsp;&nbsp; 4. 기타 (주)어셈브릭스가 추가 개발하거나 다른
              회사와의 제휴 계약 등을 통해 이용자에게 제공하는 일체의 서비스
              <br />
              ② 회원은 관계법, 이 약관의 규정, 이용안내 및 "서비스"와 관련하여
              공지한 주의사항, (주)어셈브릭스가 통지하는 사항 등을 준수하여야
              하며, 기타 (주)어셈브릭스의 업무에 방해되는 행위를 하여서는 안
              됩니다.
              <br />
              ③ (주)어셈브릭스는 재화의 품절 또는 기술적 사양의 변경 등의
              경우에는 장차 체결되는 계약에 의해 제공할 재화, 용역의 내용을
              변경할 수 있습니다. 이 경우에는 변경된 재화, 용역의 제공일자를
              명시하여 현재의 재화, 내용을 게시한 곳에 그 제공일자 이전 7일부터
              공지합니다.
              <br />
              ④ (주)어셈브릭스가 제공하기로 이용자와 이미 계약을 체결한 서비스의
              내용을 재화의 품절 또는 기술적인 사유로 변경할 경우에는
              (주)어셈브릭스는 이로 인하여 이용자가 입은 손해를 배상합니다. 단,
              (주)어셈브릭스의 고의 또는 과실이 없는 경우에는 그러하지
              아니합니다.
              <br />⑤ (주)어셈브릭스는 제1항의 서비스 중 일부에 대한 서비스
              이용시간을 별도로 정할 수 있으며, 이 경우 그 이용시간을 사전에
              이용자에게 공지 또는 통지합니다.
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              <strong>제13조 [서비스의 중단]</strong>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              ① (주)어셈브릭스는 다음 각호에 해당하는 경우 서비스의 제공을
              일시적으로 중단할 수 있습니다.
              <br />
              &nbsp;&nbsp;&nbsp; 1. (주)어셈브릭스가 사전에 이용자에게
              공지하거나 통지한 경우
              <br />
              &nbsp;&nbsp;&nbsp; 2. 컴퓨터 등 정보통신설비의 보수점검 교체 및
              고장, 통신의 두절 등의 경우
              <br />
              &nbsp;&nbsp;&nbsp; 3. 이용자의 서비스 이용 폭주 등으로 서비스
              제공이 불가능한 경우
              <br />
              &nbsp;&nbsp;&nbsp; 4. 설비 등을 긴급복구 하여야 할 경우
              <br />
              &nbsp;&nbsp;&nbsp; 5. 기간통신사업자가 전기통신서비스를 중지한
              경우
              <br />
              &nbsp;&nbsp;&nbsp; 6. 기타 (주)어셈브릭스가 합리적으로 제어할 수
              없는 경우 등<br />② (주)어셈브릭스는 제1항의 사유로 서비스의
              제공이 일시적으로 중단됨으로 인하여 이용자 또는 제3자가 입은
              손해에 대하여 배상합니다. 단 (주)어셈브릭스의 고의 또는 과실이
              없는 경우에는 그러하지 아니합니다.
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              <strong>제14조 [서비스의 변경]</strong>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              ① (주)어셈브릭스는 상당한 이유가 있는 경우에 운영상, 기술상의
              필요에 따라 제공하고 있는 전부 또는 일부 "서비스"를 변경할 수
              있습니다.
              <br />
              ② "서비스"의 내용, 이용방법, 이용시간에 대하여 변경이 있는
              경우에는 변경사유, 변경될 서비스의 내용 및 제공일자 등은 그 변경
              전에 해당 서비스 초기화면에 게시하여야 합니다.
              <br />③ (주)어셈브릭스는 무료로 제공되는 서비스의 일부 또는 전부를
              회사의 정책 및 운영의 필요상 수정, 중단, 변경할 수 있으며, 이에
              대하여 관련법에 특별한 규정이 없는 한 회원에게 별도의 보상을 하지
              않습니다.
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              <strong>제15조 [서비스 이용/이용대금]</strong>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              ① 이용자가 서비스를 이용하기 위해서는 (주)어셈브릭스가 공지사항에
              게시하거나 해당서비스 이용안내에서 제시하는 절차를 준수하여야
              하며, 해당 서비스의 내용 및 책임한계 또한 공지사항에 게시된 내용
              및 해당 서비스 이용안내에 따릅니다. 서비스이용신청은 반드시
              실명으로 하여야 합니다.
              <br />
              ② 서비스 이용대금은 (주)어셈브릭스가 공지사항에 게시하거나 해당
              서비스 이용안내에서 제시하는 바에 따릅니다. (주)어셈브릭스가
              제공하는 서비스는 그 이용대금을 별도 게시하거나 제시하지 않는 한
              무료로 합니다.
              <br />③ (주)어셈브릭스는 이용자가 구매신청한 재화 또는 용역이 품절
              등의 사유로 재화의 인도 또는 용역의 제공을 할 수 없을 때에는 지체
              없이 그 사유를 이용자에게 통지하고, 사전에 재화 또는 용역의 대금을
              받은 경우에는 그 사유발생일로부터 3일 이내에 계약해제 및
              환급절차를 취합니다. 이 경우 계약해제 및 환급에는 별도의 위약금이
              발생하지 않습니다.
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              <strong>제16조 [표시착오가 있는 경우 처리]</strong>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              (주)어셈브릭스는 “탑탑”을 통해 제공하는 서비스 정보는 정확성을
              원칙으로 합니다. 다만, 제공하는 화물자동차 운송 허가증 및
              운송주선사업 허가증 매매정보 및 가격정보 중 (주)어셈브릭스의
              과실로 실제 가격보다 낮은 가격으로 가격이 제시되었고, 해당 가격을
              확인하고 매매대금 전액을 입금한 경우, (주)어셈브릭스가 가격을
              제시하는데 중대한 과실이 없는 한 동 계약은 취소할 수 있고,
              서비스이용자는 이에 대해 이의를 제기하지 못합니다. 또한
              (주)어셈브릭스는 서비스 이용자가 구매를 위해 실행한 대출 및 보험
              등에 대해 책임지지 않습니다.
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              <strong>제17조 [연결 웹사이트와 피연결 웹사이트간의 관계]</strong>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              ① “탑탑”과 하위 "웹사이트"가 하이퍼 링크(예: 하이퍼 링크의
              대상에는 문자, 그림 및 동화상 등이 포함됨)방식 등으로 연결된 경우,
              전자를 연결 웹사이트라고 하고 후자를 피연결 웹사이트라고 합니다.
              <br />② 연결 웹사이트는 피연결 웹사이트가 독자적으로 제공하는 재화
              용역에 의하여 이용자와 행하는 거래에 대해서 보증책임을 지지
              않는다는 뜻을 연결웹사이트의 사이트에서 명시한 경우에는 그 거래에
              대한 보증책임을 지지 않습니다.
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              <strong>제18조 [저작권의 귀속 및 이용제한]</strong>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              ① (주)어셈브릭스가 작성한 저작물에 대한 저작권 기타 지적재산권은
              (주)어셈브릭스에 귀속합니다.
              <br />② 이용자는 “탑탑”을 이용함으로써 얻은 정보를
              (주)어셈브릭스의 사전 승낙 없이 복제, 송신, 출판, 배포, 방송 기타
              방법에 의하여 영리목적으로 이용하거나 제3자에게 이용하게 하여서는
              안됩니다.
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              <strong>제19조 [분쟁처리 및 분쟁조정]</strong>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              ① (주)어셈브릭스는 이용자가 제기하는 정당한 의견이나 불만을
              반영하고 그 피해를 보상처리하기 위하여 최선을 다합니다.
              <br />
              ② (주)어셈브릭스는 이용자로부터 제출되는 불만사항 및 의견은
              우선적으로 그 사항을 처리합니다. 다만, 신속한 처리가 곤란한
              경우에는 이용자에게 그 사유와 처리일정을 즉시 통보합니다.
              <br />③ (주)어셈브릭스와 이용자간에 발생한 분쟁은 “전자거래기본법”
              제28조 및 동 시행령 제15조에 의하여 설치된
              전자거래분쟁조정위원회의 조정에 따를 수 있습니다.
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              <strong>제20조 [재판권 및 준거법]</strong>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              ① (주)어셈브릭스와 이용자간에 발생한 분쟁에 관한 소송은
              민사소송법상의 관할법원에 제기합니다. 다만, 서비스 이용시
              관할법원에 대한 별도 합의가 있는 경우에는 이에 따릅니다.
              <br />② (주)어셈브릭스와 이용자간에 제기된 소송에는 한국법을
              적용합니다.
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              <strong>제21조 [데이터 베이스의 보호]</strong>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              ① (주)어셈브릭스는 서비스를 이용하여 구축되는 데이터 베이스에
              대하여 robots.txt 파일 등의 소정의 저작권 보호 장치로써 이를
              보호하고 있습니다. 보호되고 있는 데이터베이스를 타 검색 로봇이
              수집하는 것을 불허 합니다.
              <br />
              ② (주)어셈브릭스의 데이터 베이스를 계속 수집하는 경우
              <br />
              &nbsp;&nbsp;&nbsp; - (주)어셈브릭스의 고유한 서비스 정보가 유출될
              수 있습니다.
              <br />
              &nbsp;&nbsp;&nbsp; - (주)어셈브릭스 서비스의 게시물이나 창작물이
              게시자의 의사에 반하여 다른 곳에서 보여지고 원하지 않는 방향으로
              이용될 수 있습니다.
              <br />
              &nbsp;&nbsp;&nbsp; - (주)어셈브릭스 서비스 내에서 비공개로
              작성되거나 삭제된 게시물이 작성자의 의사에 반하여 공개되거나
              지속적으로 게시 유포될 수 있습니다.
              <br />③ (주)어셈브릭스의 데이터베이스를 수집해가는 행위는 고의성의
              여부를 불문하고 국제적인 인터넷 검색 서비스와 개인 정보 보호를
              위한 규칙에 어긋나는 것이며, 2번 항목과 같은 문제와 피해 사항들이
              발생할 위험이 크고, 경우에 따라 저작권 침해 또는 정보통신망
              이용촉진및 정보보호에 관한 법률 등에 위반될 수 있습니다.
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              (주)어셈브릭스의 데이터베이스에 설치된 소정의 저작권 보호 장치 및
              관련 규정을 무시하고 계속 데이터를 수집할 경우, (주)어셈브릭스의
              서버와 데이터보호뿐 아니라 저작권 보호를 위해 (주)어셈브릭스는
              해당 행위에 대하여 법적 절차를 포함하여 엄중한 책임을 물을
              것입니다.
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              <strong>
                제22조 [(주)어셈브릭스 서비스 이용에 따른 주의사항]
              </strong>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              ① (주)어셈브릭스의 사전 허락 없이 자동화된 수단(예: 매크로
              프로그램, 로봇(봇), 스파이더, 스크래퍼 등)을 이용하여 타
              서비스((주)어셈브릭스가 직접 운영하는 홈페이지, 어플리케이션
              이외의 다른 홈페이지, 어플리케이션 등 형태를 불문한 일체의 온라인
              서비스)에 (주)어셈브릭스가 직접 운영하는 홈페이지 및
              어플리케이션에 게시된 내용(화물운송사업 허가증 및 운송주선사업
              허가증의 가격, 지역, 관련 정보, 기타 부가 서비스 내용 등 모든
              서비스 정보 일체)을 무단으로 게재하는 등 정확한 정보를 제공하고자
              하는 “탑탑” 서비스의 취지에 부합하지 않는 방식으로
              (주)어셈브릭스의 서비스 정보를 이용하거나, 이와 같은
              (주)어셈브릭스 서비스 정보의 어뷰징(남용)행위를 막기위한
              (주)어셈브릭스의 기술적 조치를 무력화하려는 일체의 행위(예: IP를
              지속적으로 바꿔가며 접속하는 행위, 외부 솔루션을 통한 Captcha 우회
              등)를 시도해서는 안됩니다.
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              <strong>부칙</strong>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              가. 제1조 (시행일) 이 약관은 2025년 04월 15일부터 시행합니다.
            </S.AccordionCollapse_Text>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1">
          <Accordion.Header>
            <S.AccordionHeading padding="0">
              {isChecked2 ? (
                <S.AccordionIcon onClick={handleIconClick2}>
                  <FontAwesomeIcon icon={faCheck} />
                </S.AccordionIcon>
              ) : (
                <S.AccordionIcon color="#DADADA" onClick={handleIconClick2}>
                  <FontAwesomeIcon icon={faCheck} />
                </S.AccordionIcon>
              )}
              <S.AccordionValue color="#888888">
                개인정보 수집 및 이용 동의(필수)
              </S.AccordionValue>
            </S.AccordionHeading>
          </Accordion.Header>
          <Accordion.Body>
            <S.AccordionCollapse_Text>
              ㈜어셈브릭스(이하 “회사”)는 통신비밀보호법, 전기통신사업법,
              정보통신망 이용촉진 및 정보보호 등에 관한 법률, 개인정보보호법 등
              법령상의 개인정보보호 규정을 준수하며, 관련 법령에 의거한
              개인정보처리방침을 정하여 이용자의 권익 보호에 최선을 다하고
              있습니다.
              <br />
              <br />
              회사의 개인정보처리방침은 회사가 제공하는 “탑탑” 관련 제반 서비스
              (홈페이지, 모바일 웹/앱 포함)이용에 적용되며 다음과 같은 내용을
              담고 있습니다.
              <br />
              1. 수집하는 개인정보의 항목 및 수집방법
              <br />
              2. 개인정보의 수집 및 이용목적
              <br />
              3. 개인정보의 공유 및 제공
              <br />
              4. 개인정보의 처리위탁
              <br />
              5. 개인정보의 보유 및 이용기간
              <br />
              6. 개인정보의 파기절차 및 방법
              <br />
              7. 만 14세 미만 아동의 개인정보보호
              <br />
              8. 온라인 맞춤형 광고 서비스
              <br />
              9. 이용자의 권리와 그 행사방법
              <br />
              10. 개인정보 자동수집 장치의 설치/운영 및 거부에 관한 사항
              <br />
              11. 개인정보의 기술적/관리적 보호 대책
              <br />
              12. 개인정보보호책임자 및 담당자의 연락처
              <br />
              13. 기타
              <br />
              14. 개인위치정보의 처리
              <br />
              15. 고지의 의무
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              <strong>1. 수집하는 개인정보의 항목 및 수집방법</strong>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              첫째, 회사는 회원가입, 원활한 고객상담, 각종 서비스의 제공을 위해
              최초 회원가입 당시 아래와 같은 최소한의 개인정보를 필수항목으로
              수집하고 있습니다.
              <S.TermsTable>
                <thead>
                  <tr>
                    <S.TermsTh colSpan={2}>구분</S.TermsTh>
                    <S.TermsTh>개인정보 항목</S.TermsTh>
                    <S.TermsTh>근거</S.TermsTh>
                    <S.TermsTh>수집방법</S.TermsTh>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <S.TermsTd>회원가입</S.TermsTd>
                    <S.TermsTd>필수</S.TermsTd>
                    <S.TermsTd>
                      성명, 아이디, 비밀번호, 휴대폰번호, 이메일
                    </S.TermsTd>
                    <S.TermsTd>개인정보보호법 제15조 제1항 제1호</S.TermsTd>
                    <S.TermsTd>홈페이지, 모바일웹</S.TermsTd>
                  </tr>
                  <tr>
                    <S.TermsTd>SNS 로그인</S.TermsTd>
                    <S.TermsTd>필수</S.TermsTd>
                    <S.TermsTd>각 SNS ID에 대한 임의 식별번호</S.TermsTd>
                    <S.TermsTd>개인정보보호법 제15조 제1항 제1호</S.TermsTd>
                    <S.TermsTd>카카오톡</S.TermsTd>
                  </tr>
                  <tr>
                    <S.TermsTd>팝니다/삽니다 거래신청</S.TermsTd>
                    <S.TermsTd>필수</S.TermsTd>
                    <S.TermsTd>성명, 휴대폰번호</S.TermsTd>
                    <S.TermsTd>개인정보보호법 제15조 제1항 제1호</S.TermsTd>
                    <S.TermsTd>홈페이지, 모바일웹</S.TermsTd>
                  </tr>
                  <tr>
                    <S.TermsTd>팝니다/삽니다 매물등록</S.TermsTd>
                    <S.TermsTd>필수</S.TermsTd>
                    <S.TermsTd>성명, 휴대폰번호</S.TermsTd>
                    <S.TermsTd>개인정보보호법 제15조 제1항 제1호</S.TermsTd>
                    <S.TermsTd>홈페이지, 모바일웹</S.TermsTd>
                  </tr>
                  <tr>
                    <S.TermsTd>팝니다/삽니다 주선면허</S.TermsTd>
                    <S.TermsTd>필수</S.TermsTd>
                    <S.TermsTd>성명, 휴대폰번호</S.TermsTd>
                    <S.TermsTd>개인정보보호법 제15조 제1항 제1호</S.TermsTd>
                    <S.TermsTd>홈페이지, 모바일웹</S.TermsTd>
                  </tr>
                </tbody>
              </S.TermsTable>
              둘째, 회사는 회원가입, 팝니다 및 삽니다 거래신청, 매물등록, 마케팅
              및 광고 등 해당 서비스 제공 시 개인정보 수집에 대해 동의한
              이용자에 한해서만 아래와 같은 정보들이 수집될 수 있습니다.
              <S.TermsTable>
                <thead>
                  <tr>
                    <S.TermsTh colSpan={2}>구분</S.TermsTh>
                    <S.TermsTh>개인정보 항목</S.TermsTh>
                    <S.TermsTh>근거</S.TermsTh>
                    <S.TermsTh>수집방법</S.TermsTh>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <S.TermsTd>회원가입</S.TermsTd>
                    <S.TermsTd>선택</S.TermsTd>
                    <S.TermsTd>지역, 가입경로</S.TermsTd>
                    <S.TermsTd>개인정보보호법 제15조 제1항 제1호</S.TermsTd>
                    <S.TermsTd>홈페이지, 모바일웹</S.TermsTd>
                  </tr>
                  <tr>
                    <S.TermsTd>거래신청</S.TermsTd>
                    <S.TermsTd>선택</S.TermsTd>
                    <S.TermsTd>각 SNS ID에 대한 임의 식별번호</S.TermsTd>
                    <S.TermsTd>개인정보보호법 제15조 제1항 제1호</S.TermsTd>
                    <S.TermsTd>카카오톡</S.TermsTd>
                  </tr>
                  <tr>
                    <S.TermsTd>매물등록</S.TermsTd>
                    <S.TermsTd>선택</S.TermsTd>
                    <S.TermsTd>
                      자동차 등록증, 사업자 등록증, 화물자동차운송사업허가증
                    </S.TermsTd>
                    <S.TermsTd>개인정보보호법 제15조 제1항 제1호</S.TermsTd>
                    <S.TermsTd>홈페이지, 모바일웹</S.TermsTd>
                  </tr>
                  <tr>
                    <S.TermsTd>
                      마케팅, <br />
                      맞춤 서비스의 제공 및 광고
                    </S.TermsTd>
                    <S.TermsTd>선택</S.TermsTd>
                    <S.TermsTd>성명, 휴대폰번호</S.TermsTd>
                    <S.TermsTd>개인정보보호법 제15조 제1항 제1호</S.TermsTd>
                    <S.TermsTd>홈페이지, 모바일웹</S.TermsTd>
                  </tr>
                  <tr>
                    <S.TermsTd>거래 시</S.TermsTd>
                    <S.TermsTd>필수</S.TermsTd>
                    <S.TermsTd>
                      성사 시 별도 수집
                      <br />
                      (사업자 등록증, 자동차등록증, 화물자동차운송사업허가증,
                      인감증명)
                    </S.TermsTd>
                    <S.TermsTd>개인정보보호법 제15조 제1항 제1호</S.TermsTd>
                    <S.TermsTd>홈페이지, 모바일웹</S.TermsTd>
                  </tr>
                </tbody>
              </S.TermsTable>
              셋째, 서비스 이용과정이나 사업처리 과정에서 아래와 같은 정보들이
              자동으로 생성되어 수집될 수 있습니다.
              <br /> - 이용자의 브라우저 종류 및 OS, 검색어, 서비스 이용 기록 :
              서비스이용에 대한 통계분석
              <br /> - IP Adress, 쿠키, 방문일시, 서비스 이용기록, 불량 이용
              기록, 기기정보
              <br /> - 결제기록 : 전자금융거래기록보관
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              <strong>2. 개인정보의 수집 및 이용목적</strong>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              가. 수집하는 개인정보의 항목
              <br />
              회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.
              <S.TermsTable>
                <thead>
                  <tr>
                    <S.TermsTh>구분</S.TermsTh>
                    <S.TermsTh>개인정보 수집 및 이용 목적</S.TermsTh>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <S.TermsTd>회원관리</S.TermsTd>
                    <S.TermsTd>
                      회원제 서비스 제공, 개인식별, 이용약관 위반 회원에 대한
                      이용제한 조치, 서비스의 원활한 운영에 지장을 미치는 행위
                      및 서비스 부정이용 행위 제재, 가입의사 확인, 가입 및
                      가입횟수 제한
                    </S.TermsTd>
                  </tr>
                  <tr>
                    <S.TermsTd>
                      서비스 제공에 관한 계약 이행 및 서비스 제공에 따른
                      대금정산
                    </S.TermsTd>
                    <S.TermsTd>
                      컨텐츠 제공, 특정 맞춤 서비스 제공, 청구서 등 발송,
                      본인인증, 대금 결제, 요금 추심, 서류대행 서비스를 위한
                      본인확인, 분쟁조정을 위한 기록보존, 불만처리 등 민원처리,
                      고지사항 전달
                    </S.TermsTd>
                  </tr>
                  <tr>
                    <S.TermsTd>
                      신규 서비스 개발 및 맞춤 서비스 제공 혜택/정보 수신
                    </S.TermsTd>
                    <S.TermsTd>
                      신규 서비스 개발 및 맞춤 서비스 제공, 통계학적 특성에 따른
                      서비스 제공 및 광고 게재, 서비스의 유효성 확인, 이벤트
                      정보 및 참여기회 제공, 광고성 정보 제공, 접속빈도 파악,
                      회원의 서비스이용에 대한 통계
                    </S.TermsTd>
                  </tr>
                  <tr>
                    <S.TermsTd>수집한 개인정보의 이용목적 구분</S.TermsTd>
                    <S.TermsTd>
                      - 성명, 아이디, 비밀번호: 회원제 서비스 이용에 따른 본인
                      확인절차에 이용
                      <br />- 이메일, 전화번호, 연락처(전화번호, 휴대전화번호) :
                      고지사항 전달 및 본인의사확인, 불만처리, 사용자구분등
                      원활한 의사소통 경로의 확보
                    </S.TermsTd>
                  </tr>
                </tbody>
              </S.TermsTable>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              <strong>3. 개인정보의 제3자 제공</strong>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              회사는 이용자의 개인정보를 "2. 개인정보의 수집 및 이용목적"에서
              고지한 범위 내에서 사용하며, 이용자의 사전 동의 없이는 동 범위를
              초과하여 이용하거나 원칙적으로 이용자의 개인정보를 외부에 공개하지
              않습니다. 다만, 아래의 경우에는 예외로 합니다.
              <br />
              <br />- 기타 법에 의해 요구된다고 선의로 판단되는 경우 (예. 관련
              법령에 의거 적법한 절차에 의한 정부/수사기관의 요청이 있는 경우
              등)
              <br />- 서비스 이용에 필요한 목적을 위해 이용자의 개인정보에
              대해서 제3자에게 제공(별도 이용자의 동의 여부 확인)
              <br />
              <br />
              이용자가 온라인상의 게시판 등을 통해 기재한 인적사항을 제3자가
              수집하는 경우가 있을 수 있으므로 이에 유의하시기 바랍니다.
              이용자가 스스로 게시판 등을 통해 기재한 인적사항과 관련하여 회사는
              어떠한 책임도 지지 않습니다.
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              <strong>4. 개인정보의 처리위탁</strong>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              회사는 서비스 향상을 위해서 필요한 경우 및 기타 서비스 제공을
              위해서 이용자의 개인정보를 아래와 같은 업무를 위탁하여 운영하고
              있습니다.
              <br />
              수탁자에 대해서는 관련 법규 및 지침의 준수, 정보보호 및 비밀유지,
              제3자제공금지, 사고 시 책임부담, 위탁기간 종료 즉시 개인정보의
              반납.파기 의무 등을 규정하여 관리/감독하고 있습니다. 또한 회사는
              위탁업무의 내용이나 수탁자가 변경될 경우에는 지체 없이 본
              개인정보처리방침을 통하여 공개 하도록 하겠습니다.
              <br />
              <br />
              [개인정보처리의 위탁내역]
              <S.TermsTable>
                <thead>
                  <tr>
                    <S.TermsTh>수탁업체</S.TermsTh>
                    <S.TermsTh>위탁 업무</S.TermsTh>
                    <S.TermsTh>보유기간</S.TermsTh>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <S.TermsTd>카카오</S.TermsTd>
                    <S.TermsTd>본인확인</S.TermsTd>
                    <S.TermsTd>
                      업체에서 이미 보유하고 있는 개인정보이기 때문에
                      ㈜어셈브릭스는 별도로 저장하지 않음
                    </S.TermsTd>
                  </tr>
                </tbody>
              </S.TermsTable>
            </S.AccordionCollapse_Text>

            <S.AccordionCollapse_Text>
              <strong>5. 개인정보의 보유 및 이용기간</strong>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              회사는 이용자가 회원으로서 서비스를 이용하는 동안 이용자의
              개인정보를 보유 및 이용하며, 이용자가 회원탈퇴를 요청한 경우나
              개인정보의 수집 및 이용목적을 달성하거나 보유 및 이용기간이 종료한
              경우 또는 사업폐지 등의 사유가 발생한 경우 해당 정보를 지체 없이
              파기합니다.
              <br />
              <br />
              단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안
              보존합니다.
              <S.TermsUl>
                <li>가. 개인정보 보유 및 이용기간</li>
                <li>
                  &nbsp;- 부정이용기록의 경우: 부정이용에 대한 적법한 절차 및
                  방지 작업이 종료된 때
                </li>
                <li>
                  &nbsp;- 회원 가입 정보의 경우: 회원탈퇴 시 또는 회원 자격을
                  상실한 때
                </li>
                <li>
                  &nbsp;- 설문조사, 이벤트 목적을 위해 수집한 경우: 해당
                  설문조사, 이벤트가 종료한 때
                </li>
                <li>
                  &nbsp;- 기타보유정보: 정보의 수집 및 이용 목적이 달성된 때
                </li>
              </S.TermsUl>
              <S.TermsUl>
                <li>나. 관련법령에 의한 정보보호 사유</li>
                <li>
                  상법, 전자상거래 등에서의 소비자보호에 관한 법률 등 관계
                  법령의 규정에 의하여 보존할 필요가 있는 경우 회사는
                  관계법령에서 정한 일정한 기간 동안 회원정보를 보관합니다. 이
                  경우 회사는 보관하는 정보를 그 보관의 목적으로만 이용하며
                  보존기간은 아래와 같습니다.
                </li>
                <li>
                  <S.TermsTable>
                    <thead>
                      <tr>
                        <S.TermsTh>대 상</S.TermsTh>
                        <S.TermsTh>관련 법 조항</S.TermsTh>
                        <S.TermsTh>보유기간</S.TermsTh>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <S.TermsTd>계약 또는 청약철회 등에 관한 기록</S.TermsTd>
                        <S.TermsTd>
                          전자상거래 등에서의 소비자보호에 관한 법률
                        </S.TermsTd>
                        <S.TermsTd>5년</S.TermsTd>
                      </tr>
                      <tr>
                        <S.TermsTd>
                          대금결제 및 재화 등의 공급에 관한 기록
                        </S.TermsTd>
                        <S.TermsTd>
                          전자상거래 등에서의 소비자보호에 관한 법률
                        </S.TermsTd>
                        <S.TermsTd>5년</S.TermsTd>
                      </tr>
                      <tr>
                        <S.TermsTd>고유식별정보에 관한 기록</S.TermsTd>
                        <S.TermsTd>
                          전자상거래 등에서의 소비자 보호에 관한 법률, 국세
                          기본법 제26조의2
                        </S.TermsTd>
                        <S.TermsTd>5년</S.TermsTd>
                      </tr>
                      <tr>
                        <S.TermsTd>
                          소비자의 불만 또는 분쟁처리에 관한 기록
                        </S.TermsTd>
                        <S.TermsTd>
                          전자상거래 등에서의 소비자보호에 관한 법률
                        </S.TermsTd>
                        <S.TermsTd>3년</S.TermsTd>
                      </tr>
                      <tr>
                        <S.TermsTd>본인확인에 관한 기록</S.TermsTd>
                        <S.TermsTd>
                          정보통신 이용촉진 및 정보보호 등에 관한 법률
                        </S.TermsTd>
                        <S.TermsTd>6개월</S.TermsTd>
                      </tr>
                      <tr>
                        <S.TermsTd>
                          컴퓨터 통신 및 인터넷 로그기록자료, 접속지 추적자료
                        </S.TermsTd>
                        <S.TermsTd>
                          통신비밀보호법 제15조의2 및 동법 시행령 제41조
                        </S.TermsTd>
                        <S.TermsTd>3개월</S.TermsTd>
                      </tr>
                    </tbody>
                  </S.TermsTable>
                </li>
              </S.TermsUl>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              <strong>6. 개인정보 파기절차 및 방법</strong>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              회사는 다른 법률에 따라 개인정보를 보존하여야 하는 경우가 아닌 한,
              수집한 이용자의 개인정보의 수집 및 이용목적이 달성되거나,
              가명정보의 처리기간 경과, 이용자가 회원탈퇴를 요청한 경우 지체
              없이 파기하여 향후 어떠한 용도로도 열람 또는 이용할 수 없도록
              처리합니다. 단, “5.개인정보의 보유 및 이용기간 가, 나”와 같은 예외
              경우를 두고 있습니다.
              <br />
              회사의 개인정보 파기절차 및 방법은 다음과 같습니다.
              <S.TermsUl>
                <li>가. 파기절차 </li>
                <li>
                  이용자가 회원가입 등을 위해 입력한 정보는 목적이 달성된 후
                  별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및
                  기타 관련 법령에 의한 정보보호 사유에 따라(5. 보유 및 이용기간
                  참조)일정 기간 저장된 후 파기됩니다.
                </li>
                <li>
                  동 개인정보는 법률에 의한 경우가 아니고서는 보유되는 이외의
                  다른 목적으로 이용되지 않습니다.
                </li>
              </S.TermsUl>
              <S.TermsUl>
                <li>나. 파기방법 </li>
                <li>
                  종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여
                  파기하며, 전자적 파일 형태로 저장된 개인정보는 기록을 재생할
                  수 없는 기술적 방법을 사용하여 삭제합니다.
                </li>
              </S.TermsUl>
              <S.TermsUl>
                <li>미이용자의 개인정보 파기 등에 관한 조치 </li>
                <li>
                  휴면회원의 개인정보는 다른 회원의 개인정보와 분리하여 별도로
                  저장/관리 되며, 분리 저장된 개인정보는 3년 보관기간 경과 후
                  파기하고 있습니다.
                </li>
              </S.TermsUl>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              <strong>7. 만 14세 미만 아동의 개인정보보호</strong>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              회사가 운영하는 사이트에서는 만14세 미만 아동의 경우 회원 가입이
              불가능합니다.
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              <strong>8. 온라인 맞춤형 광고 서비스</strong>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              회사는 서비스 이용과정에서 고객에게 최적화된 맞춤형 서비스 및
              혜택, 온라인 맞춤형 광고 등을 제공하기 위하여 행태정보를
              수집/이용하고 있습니다.
              <S.TermsTable>
                <tbody>
                  <tr>
                    <S.TermsTd>수집하는 행태정보의 항목</S.TermsTd>
                    <S.TermsTd>
                      고객의 탑탑 웹/앱 서비스 방문이력, 검색이력, 구매이력
                    </S.TermsTd>
                  </tr>
                  <tr>
                    <S.TermsTd>행태정보의 수집방법</S.TermsTd>
                    <S.TermsTd>
                      고객의 탑탑 웹/앱 서비스 방문/실행 시 자동수집
                    </S.TermsTd>
                  </tr>
                  <tr>
                    <S.TermsTd>행태정보 수집목적</S.TermsTd>
                    <S.TermsTd>
                      - 고객 개인의 관심 분야에 따른 정보 제공
                      <br />- 접속빈도 또는 방문시간 등을 분석하고 이용자의
                      취향과 관심분야를 파악하여 타겟 마케팅 및 서비스 개선
                      척도로 활용
                      <br />- 검색한 품목들에 대한 정보와 관심있게 둘러본 품목을
                      추적하여 개인 맞춤 매물 및 정보 추천
                    </S.TermsTd>
                  </tr>
                  <tr>
                    <S.TermsTd>이용자 통제권 행사방법</S.TermsTd>
                    <S.TermsTd>
                      - 인터넷익스플로러의 경우, 웹브라우저 상단의
                      [도구]→[인터넷옵션]→[개인정보]→[고급] 메뉴를 통하여 쿠키
                      설정 거부
                      <br /> - Safari의 경우, Mac OS 상단 좌측 메뉴바에서
                      [Safari]→[환경설정]→[보안]을 통하여 쿠키 허용 여부 설정
                      <br /> - 안드로이드 계열: 설정→애플리케이션→'탑탑'앱
                      선택→권한→접근항목별 '허용' 또는 '허용안함' 체크
                      <br /> - ios 계열: 설정→'탑탑'앱 선택→접근권한 별 동의
                      또는 철회 체크
                    </S.TermsTd>
                  </tr>
                </tbody>
              </S.TermsTable>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              <strong>9. 이용자의 권리와 그 행사방법</strong>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              이용자는 언제든지 등록되어 있는 자신의 개인정보를 조회하거나
              수정할 수 있으며 가입해지(동의철회)를 요청할 수도 있습니다.
              <br />
              <br />
              이용자는 개인정보관리책임자에게 완전히 자동화된 개인정보 처리에
              따른 결정을 거부하거나 그에 대한 설명 등을 요청하실 수 있습니다.
              <br />
              <br />
              이용자의 개인정보 조회, 수정을 위해서는 '개인정보변경'(또는
              '회원정보수정' 등)을, 가입해지(동의철회)를 위해서는 ’회원탈퇴’를
              클릭하여 본인 확인 절차를 거치신 후 직접 열람, 정정 또는 탈퇴가
              가능합니다.
              <br />
              <br />
              혹은 개인정보관리책임자에게 서면, 전화 또는 이메일로 연락하시면
              지체 없이 조치하겠습니다. 이용자가 개인정보의 오류에 대한 정정을
              요청하신 경우에는 정정을 완료하기 전까지 당해 개인정보를 이용 또는
              제공하지 않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한
              경우에는 정정 처리결과를 제3자에게 지체 없이 통지하여 정정이
              이루어지도록 하겠습니다.
              <br />
              <br />
              회사는 이용자 혹은 법정 대리인의 요청에 의해 해지 또는 삭제된
              개인정보는 "5. 개인정보의 보유 및 이용기간"에 명시된 바에 따라
              처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고
              있습니다.
              <br />
              <br />
              이용자는 자신의 개인정보의 처리 여부를 확인할 수 있으며 개인정보에
              대한 열람 및 전송을 요청할 수도 있습니다.
              <br />
              <br />
              단, 이용자의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 권리
              행사를 하실 경우 위임장을 제출하셔야 합니다.
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              <strong>
                10. 개인정보 자동 수집 장치의 설치/운영 및 거부에 관한 사항
              </strong>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              회사는 이용자들에게 특화된 맞춤서비스를 제공하기 위해서 이용자들의
              정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를 사용합니다.
              쿠키는 웹사이트를 운영하는 데 이용되는 서버(HTTP)가 이용자의
              컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터
              내의 하드디스크에 저장되기도 합니다.
              <S.TermsUl>
                <li>가. 쿠키의 사용 목적</li>
                <li>
                  이용자들이 방문한 회사의 각 서비스와 웹 사이트들에 대한 로그인
                  여부 등을 파악하여 이용자에게 최적화된 정보 제공을 위하여
                  사용합니다. 또한 이용자의 접속 빈도나 방문 시간 등을 분석하고
                  이용자의 취향과 관심분야를 파악하여 타겟(Target) 마케팅 및
                  서비스 개편 등의 척도로 활용합니다.
                </li>
              </S.TermsUl>
              <S.TermsUl>
                <li>나. 쿠키의 설치/운영 및 거부</li>
                <li>
                  이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서,
                  이용자는 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를
                  허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든
                  쿠키의 저장을 거부할 수도 있습니다.
                </li>
                <li>
                  쿠키 설정을 거부하는 방법으로는 이용자가 사용하는 웹
                  브라우저의 옵션을 선택함으로써 모든 쿠키를 허용하거나 쿠키를
                  저장할 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수
                  있습니다.
                </li>
              </S.TermsUl>
              <S.TermsUl>
                <li>웹 브라우저(쿠키 설정)</li>
                <li>
                  &nbsp;- Internet Explorer: 메뉴 {">"} 도구 {">"} 인터넷옵션{" "}
                  {">"} 일반 {">"} 검색 기록 {">"} ‘삭제’ 및 ‘설정’
                </li>
                <li>
                  &nbsp;- Chrome: 메뉴 {">"} 설정 {">"} ‘개인정보 및 보안’
                </li>
                <li>
                  &nbsp;- Safari: 환경설정 {">"} ‘크로스 사이트 추적 방지’ 및
                  ‘모든 쿠키 차단’
                </li>
                <li>
                  &nbsp;- 이 외에도 Firefox, Opera 등 주요 인터넷 웹브라우저들도
                  쿠키 삭제 기능을 제공하고 있습니다.
                </li>
              </S.TermsUl>
              <S.TermsUl>
                <li>모바일 웹, 앱(쿠키, 광고식별)</li>
                <li>
                  &nbsp;- Android: 디바이스 설정 {">"} Google {">"} 광고 {">"}{" "}
                  광고 맞춤설정 선택 해제 (ON)
                </li>
                <li>
                  &nbsp;- iPhone: 디바이스 설정 {">"}개인 정보 보호 {">"} 추적{" "}
                  {">"} 앱이 추적을 요청하도록 허용 (OFF)
                </li>
              </S.TermsUl>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              <strong>11. 개인정보의 기술적/관리적 보호 대책</strong>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              회사는 이용자들의 개인정보를 처리함에 있어 개인정보가 분실, 도난,
              누출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은
              기술적/관리적 대책을 강구하고 있습니다.
              <S.TermsUl>
                <li>가. 개인정보 암호화</li>
                <li>
                  이용자의 주요 개인정보는 암호화하여 저장하고 있으며, 파일 및
                  전송데이터를 암호화하여 혹시 발생할 수 있는 사고 시라도
                  이용자의 개인정보가 유출되지 않도록 관리되고 있습니다.
                </li>
              </S.TermsUl>
              <S.TermsUl>
                <li>나. 해킹 등에 대비한 대책</li>
                <li>
                  회사는 해킹이나 컴퓨터 바이러스 등에 의해 이용자의 개인정보가
                  유출되거나 훼손되는 것을 막기 위해 최선을 다하고 있습니다.
                  개인정보의 훼손에 대비해서 자료를 수시로 백업하고 있고, 최신
                  백신프로그램을 이용하여 이용자들의 개인정보나 자료가
                  누출되거나 손상되지 않도록 방지하고 있으며, 암호화 통신 등을
                  통하여 네트워크상에서 개인정보를 안전하게 전송할 수 있도록
                  하고 있습니다. 그리고 24시간 침입차단시스템을 이용하여
                  외부로부터의 무단 접근을 통제하고 있으며, 기타 시스템적으로
                  보안성을 확보하기 위한 가능한 모든 기술적 장치를 갖추려
                  노력하고 있습니다
                </li>
              </S.TermsUl>
              <S.TermsUl>
                <li>다. 처리 직원의 최소화 및 교육</li>
                <li>
                  회사의 개인정보관련 처리 직원은 담당자에 한정시키고 있고 이를
                  위한 별도의 비밀번호를 부여하여 정기적으로 갱신하고 있으며,
                  담당자에 대한 수시 교육을 통하여 개인정보처리방침의 준수를
                  항상 강조하고 있습니다.
                </li>
              </S.TermsUl>
              <S.TermsUl>
                <li>라. 개인정보보호전담기구의 운영</li>
                <li>
                  사내 개인정보보호전담기구 등을 통하여 회사의
                  개인정보처리방침의 이행사항 및 담당자의 준수여부를 확인하여
                  문제가 발견될 경우 즉시 수정하고 바로 잡을 수 있도록 노력하고
                  있습니다. 단, 회사가 개인정보보호 의무를 다 하였음에도
                  불구하고 이용자 본인의 부주의나 회사가 관리하지 않는
                  영역에서의 사고 등 회사의 귀책에 기인하지 않은 손해에 대해서는
                  회사는 책임을 지지 않습니다.
                </li>
              </S.TermsUl>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              <strong>12. 개인정보보호 책임자 및 담당자의 연락처</strong>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              회사는 개인정보에 대한 의견수렴 및 불만처리를 담당하는
              개인정보보호책임자 및 담당자를 지정하고 있고, 연락처는 아래와
              같습니다.
              <S.TermsUl>
                <li>가. 개인정보보호책임자</li>
                <li>이름 : 강신장</li>
                <li>소속 : 정보보호담당</li>
                <li>E-MAIL : sh.kang@assembrix.co.kr</li>
              </S.TermsUl>
              <S.TermsUl>
                <li>나. 개인정보보호담당자</li>
                <li>
                  <S.TermsTable>
                    <thead>
                      <tr>
                        <S.TermsTh>사이트</S.TermsTh>
                        <S.TermsTh>담당자</S.TermsTh>
                        <S.TermsTh>소속/직위</S.TermsTh>
                        <S.TermsTh>E-Mail</S.TermsTh>
                        <S.TermsTh>전화번호</S.TermsTh>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <S.TermsTd>탑탑(www.top-top.kr)</S.TermsTd>
                        <S.TermsTd>강신장</S.TermsTd>
                        <S.TermsTd>정보보안팀/상무</S.TermsTd>
                        <S.TermsTd>sh.kang@assembrix.co.kr</S.TermsTd>
                        <S.TermsTd>010-4478-8944</S.TermsTd>
                      </tr>
                    </tbody>
                  </S.TermsTable>
                </li>
                <li>
                  이용자는 회사의 서비스를 이용하시며 발생하는 모든 개인정보보호
                  관련 민원을 개인정보보호책임자 혹은 담당부서로 신고하실 수
                  있습니다. 회사는 이용자들의 신고사항에 대해 신속하게 충분한
                  답변을 드릴 것입니다.
                </li>
                <li>
                  <br />
                  기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래
                  기관에 문의하시기 바랍니다.
                </li>
                <li><br />- 개인정보침해신고센터 (privacy.kisa.or.kr / 국번없이 118)</li>
                <li>- 개인정보분쟁조정위원회 (www.kopico.go.kr / 국번없이 1833-6972)</li>
                <li>- 대검찰청 사이버수사과 (www.spo.go.kr / 국번없이 1301)</li>
                <li>- 사이버범죄 신고시스템 (ecrm.police.go.kr / 국번없이 182)</li>
              </S.TermsUl>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              <strong>13. 기타</strong>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              회사가 운영하는 사이트에 링크되어 있는 웹사이트들이 개인정보를
              수집하는 행위에 대해서는 본 "탑탑 개인정보처리방침"이 적용되지
              않음을 알려 드립니다.
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              <strong>14. 고지의 의무</strong>
            </S.AccordionCollapse_Text>
            <S.AccordionCollapse_Text>
              현 개인정보처리방침 내용 추가, 삭제 및 수정이 있을 시에는 개정
              최소 7일 전부터 변경이유 및 내용을 홈페이지의 '공지사항'을 통해
              고지할 것입니다.
              <br />
              <br />본 개인정보처리방침의 내용은 수시로 변경될 수 있으므로
              사이트를 방문하실 때마다, 이를 확인하시기 바랍니다.
              <S.TermsUl>
                <li>- 개인정보처리방침 버전번호 : Ver 1.0</li>
                <li>- 공고일자 : 2025년 06월 01일</li>
                <li>- 시행일자 : 2025년 06월 01일</li>
              </S.TermsUl>
            </S.AccordionCollapse_Text>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="2">
          <Accordion.Header>
            <S.AccordionHeading padding="0">
              {isChecked3 ? (
                <S.AccordionIcon onClick={handleIconClick3}>
                  <FontAwesomeIcon icon={faCheck} />
                </S.AccordionIcon>
              ) : (
                <S.AccordionIcon color="#DADADA" onClick={handleIconClick3}>
                  <FontAwesomeIcon icon={faCheck} />
                </S.AccordionIcon>
              )}
              <S.AccordionValue color="#888888">
                매물 시세 수신 동의(필수)
              </S.AccordionValue>
            </S.AccordionHeading>
          </Accordion.Header>
          <Accordion.Body>
            <S.AccordionCollapse_Text>
              『탑탑』은 회원님이 수집 및 이용에 동의한 개인정보를 이용하여
              SMS(MMS), SNS 메시지, 이메일, APP PUSH 알림 등 다양한 전자적 전송
              매체를 통해 오전 9시부터 오후 6시까지 매물시세를 전송할 수
              있습니다.
              <br />
              <br />
              본 동의는 거부할 수 있으나, 거부 시 실시간으로 매물시세를 받아볼
              수 없습니다.
              <br />
              <br />
              매물시세 수신의 변경은
              <br />
              <br />
              {/* 1. “탑탑” 고객센터로 요청하거나<br/> */}
              1.『탑탑』고객센터(010-4478-8944, help@assembrix.co.kr)로
              요청하거나
              <br />
              2.『탑탑』홈페이지(또는 애플리케이션)에서 로그인 후, [ 마이페이지{" "}
              {">"} 알림정보 {">"} 알림설정 ]에서 언제든지 변경하실 수 있습니다.
              <br />
            </S.AccordionCollapse_Text>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="3">
          <Accordion.Header>
            <S.AccordionHeading padding="0">
              {isChecked4 ? (
                <S.AccordionIcon onClick={handleIconClick4}>
                  <FontAwesomeIcon icon={faCheck} />
                </S.AccordionIcon>
              ) : (
                <S.AccordionIcon color="#DADADA" onClick={handleIconClick4}>
                  <FontAwesomeIcon icon={faCheck} />
                </S.AccordionIcon>
              )}
              <S.AccordionValue color="#888888">
                광고성 정보 수신동의(선택)
              </S.AccordionValue>
            </S.AccordionHeading>
          </Accordion.Header>
          <Accordion.Body>
            <S.AccordionCollapse_Text>
              『탑탑』은 회원님이 수집 및 이용에 동의한 개인정보를 이용하여
              SMS(MMS), SNS 메시지, 이메일, APP PUSH 알림 등 다양한 전자적 전송
              매체를 통해 오전 9시부터 오후 6시까지 개인 맞춤형 광고 및 정보를
              전송할 수 있습니다.
              <br />
              <br />
              본 동의는 거부할 수 있으나, 거부 시 이벤트 및 프로모션 안내,
              유용한 광고를 받아볼 수 없습니다.
              <br />
              <br />
              광고성 정보 수신의 변경은
              <br />
              <br />
              1.『탑탑』고객센터(010-4478-8944, help@assembrix.co.kr)로
              요청하거나
              <br />
              2.『탑탑』홈페이지(또는 애플리케이션)에서 로그인 후, [ 마이페이지{" "}
              {">"} 알림정보 {">"} 알림설정 ]에서 언제든지 변경하실 수 있습니다.
              <br />
            </S.AccordionCollapse_Text>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    );
}

export default AccordianCorporationUser;